module.exports = __webpack_public_path__ + "static/media/8769.3e83334c.png";